import React from 'react';
import Isvg from 'react-inlinesvg';
import './Checkbox.css';

const propTypes = {
  checked: React.PropTypes.bool.isRequired,
  id: React.PropTypes.string.isRequired,
  onChange: React.PropTypes.func.isRequired
}

const Checkbox = props => (
  <label className='checkbox' htmlFor={props.id}>
    <input
      className='checkbox__input'
      id={props.id}
      type='checkbox'
      checked={props.checked}
      onChange={props.onChange}/>
      {props.checked ?
        <Isvg
          src={`${process.env.PUBLIC_URL}/icons/checkmark.svg`}
          cacheGetRequests={true}/>
      : null}
  </label>
)

Checkbox.propTypes = propTypes;

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Checkbox/Checkbox.js